module.exports = __webpack_public_path__ + "static/media/de.e4e14e32.jpg";